import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    childCount: (count: number) => string | React.ReactNode;
    guestName: (memberName: string) => string | React.ReactNode;
    pending: string;
    alreadyHasAccess: string;
    tooltipHasAccess: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Count of users */
            childCount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number) => __intl__.intl().formatMessage({ id: "MemberAccessRow.childCount?c=30tg5ik56a51p", defaultMessage: "{count, plural, one {1 User} other {{var, select, true {100+} other {{count}}} Users}}" }, { count: count, var: count > 100 }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for guest name */
            guestName: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (memberName: string) => __intl__.intl().formatMessage({ id: "MemberAccessRow.guestName?c=3uqjdhy71qbbx", defaultMessage: "{memberName} \u00B7 Guest" }, { memberName: memberName }));
                },
                enumerable: true,
                configurable: true
            },
            /** Pending user label */
            pending: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessRow.pending?c=1hdx1m8rhv786", defaultMessage: "Pending User" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for an already added user */
            alreadyHasAccess: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessRow.alreadyHasAccess?c=2blarms8yqan3", defaultMessage: "Already has access" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Tooltip text for duplicated access */
            tooltipHasAccess: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessRow.tooltipHasAccess?c=3ilnak9mpc9b1", defaultMessage: "This user was already added or is an Admin or Content Owner" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
